import {styled} from "@mui/material/styles";
import BaseDialog from "@mui/material/Dialog";
import {forwardRef, Ref} from "react";
import {TransitionProps} from "@mui/material/transitions";
import Slide, {SlideProps} from "@mui/material/Slide";

export const SlideTransition = forwardRef((
    props: TransitionProps & { children: SlideProps["children"] },
    ref: Ref<unknown>,
) => (
    <Slide direction="up" ref={ref} {...props} />
));

const Dialog = styled(BaseDialog)({
    '.MuiDialogActions-root button': {
        minWidth: 100,
    }
})

export default Dialog
